
export default function Home() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">Welcome to Our Business</h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            We provide exceptional services to help your business grow and succeed.
          </p>
          <button className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors">
            Get Started
          </button>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="text-blue-600 text-4xl mb-4">✓</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Quality Service</h3>
            <p className="text-gray-600">We deliver exceptional results that exceed expectations.</p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="text-blue-600 text-4xl mb-4">⚡</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Fast & Efficient</h3>
            <p className="text-gray-600">Quick turnaround times without compromising quality.</p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="text-blue-600 text-4xl mb-4">★</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Trusted Partner</h3>
            <p className="text-gray-600">Building lasting relationships with our clients.</p>
          </div>
        </div>

    </div>
  );
}
